import React from 'react';
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { url } from "../../../../env";
import { AuthContext } from "../../../../Context/AuthContext";
import { Tree } from 'primereact/tree';
import { set } from "react-hook-form";
import { Loader } from "../../../../Components";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
// import { NodeService } from './service/NodeService';



export const Clients = ({ nodes, setNodes, toast, isFetching, setIsFetching }) => {
    const { authInfo, logout } = useContext(AuthContext);

    const [selectedNodeKey, setSelectedNodeKey] = useState('');
    const [budgetsArray, setBudgetsArray] = useState([]);

    const [infoBudget, setInfoBudget] = useState({});


    // const navigate = useNavigate();

    // Validar si el usuario es admin
    useEffect(() => {
        const admin = authInfo?.user?.type_user;
        if (authInfo?.user?.type_user !== "1") {
            // navigate("/login");
        }
    }, [authInfo]);



    const getAllData = async () => {
        setIsFetching(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${url}/clients`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            setNodes(prev => [
                {
                    key: '0',
                    label: 'Documentos',
                    data: 'Documents Folder',
                    icon: 'pi pi-fw pi-inbox',
                    children: Object.values(res.data).map((item, index) => {
                        let namesTypePerson = Object.keys(res.data);

                        const newObject = Object.entries(item).map(([key, value], childIndex) => {
                            let names = Object.keys(value);

                            const childrenArray = names.flatMap((name, i) => {
                                if (name === "budget") {
                                    setBudgetsArray(prev => {
                                        return {
                                            ...prev,
                                            [key]: value[name]
                                        };
                                    });
                                    return []; // Excluir presupuesto del árbol de nodos
                                }

                                let namee = name;

                                if (name === "compraante_fiscal") {
                                    namee = "Comprobante_fiscal";
                                }

                                const childrenMapped = Object.values(value[name])
                                    .flatMap((child, j) => {
                                        if (Array.isArray(child)) {
                                            const nameeBeforeFolder = Object.keys(value[name])[j];
                                            return {
                                                key: `0-${index}-${childIndex}-${i}-${j}-folder`,
                                                label: nameeBeforeFolder,
                                                icon: 'pi pi-fw pi-folder',
                                                data: 'folder document',
                                                user: key.split("-")[0],
                                                children: child.map((file, fileIndex) => {
                                                    const label = String(file);
                                                    return {
                                                        key: `0-${index}-${childIndex}-${i}-${j}-${fileIndex}`,
                                                        label: label,
                                                        icon: 'pi pi-fw pi-file',
                                                        data: 'Document',
                                                        route: `${namesTypePerson[index]}/${key}/${name}/${nameeBeforeFolder}/${label}`
                                                    };
                                                })
                                            };
                                        } else {
                                            const label = String(child);
                                            return {
                                                key: `0-${index}-${childIndex}-${i}-${j}`,
                                                label: label,
                                                icon: 'pi pi-fw pi-file',
                                                data: 'Document',
                                                route: `${namesTypePerson[index]}/${key}/${name}/${label}`,
                                                command: () => alert('hola')
                                            };
                                        }
                                    })
                                    .filter(Boolean);

                                return {
                                    key: `0-${index}-${childIndex}-${i}`,
                                    label: namee,
                                    icon: 'pi pi-fw pi-folder',
                                    data: 'folder document',
                                    children: childrenMapped
                                };
                            }).filter(child => child.children && child.children.length > 0);

                            return {
                                key: `0-${index}-${childIndex}`,
                                label: key,
                                data: 'id user',
                                icon: 'pi pi-fw pi-cog',
                                children: childrenArray
                            };
                        }).filter(child => child.children && child.children.length > 0);

                        return {
                            key: `0-${index}`,
                            label: `Persona ${namesTypePerson[index]}`,
                            data: 'Type user',
                            icon: 'pi pi-fw pi-user',
                            children: newObject
                        };
                    })
                }
            ]);

            setIsFetching(false);
        } catch (e) {
            setIsFetching(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al obtener datos', life: 5000 });
        }
    };

    const loadOnExpand = event => {
        if (
            event.node.label && /^[0-9]+-[A-Za-z]+( [A-Za-z]+)*/.test(event.node.label)
        ) {
            const id = event.node.label;
            const budget = budgetsArray[id];
            setInfoBudget(budget);
        }
    };

    const [urlFile, setUrlFile] = useState('');

    const [fileType, setFileType] = useState(null);
    const [isError, setIsError] = useState(false);

    const onSelect = async (event) => {
        if (event.node?.data === 'Document') {
            setIsFetching(true);
            try {
                const token = localStorage.getItem('token');
                const file = event.node?.route;
                const iduser = event.node?.route.split('/')[1].split('-')[0];
                const fileName = file.split('/')[0] + '/' + iduser + '/' + file.split('/').slice(2).join('/');

                const response = await axios.post(
                    `${url}/downloadFile`,
                    { fileName },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.data.url) {
                    setFileType(response.data.mimeType);
                    // Abre el archivo en una nueva pestaña
                    setUrlFile(response.data.url);
                    // window.open(response.data.url, '_blank');

                } else {
                    toast.current.show({ severity: 'error', summary: ' Error', detail: response.data.error, life: 5000 });
                    setIsError(true);
                }
            } catch (error) {
                console.error('Error fetching file:', error);
                toast.current.show({ severity: 'error', summary: ' Error', detail: 'Error al obtener archivo', life: 5000 });
                setIsError(true);
            } finally {
                setSelectedNodeKey('');
                setIsFetching(false);

            }

        }
    };

    const sizeWindow = 900;

    useEffect(() => {
        const fetchData = async () => {
            setIsFetching(true); // Iniciar la obtención de datos
            await getAllData();
            setIsFetching(false); // Finalizar la obtención de datos
        };

        // Verificar si el usuario es admin, si no se han cargado los nodos, y si no está obteniendo datos
        if (authInfo?.user?.type_user === "1" && nodes.length === 0 && !isFetching) {
            fetchData();
        }
    }, [authInfo, nodes.length, isFetching]);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= sizeWindow);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= sizeWindow);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            {(isMobile && isFetching) && (
                <Loader />
            )}
            {(!isMobile && isFetching) && (
                <Loader />
            )}
            <div className="card"
                style={{
                    display: 'flex', // Alinea los elementos en fila (horizontal)
                    justifyContent: infoBudget && Object.keys(infoBudget).length > 0 ? 'space-around' : 'flex-start',
                    width: '100%',
                    position: 'relative', // Aseguramos que el contenedor padre sea el punto de referencia para el contenedor hijo
                }}
            >
                {/* Árbol de navegación a la izquierda */}
                <div style={{
                    width: '35%', marginRight: '1rem',

                    ...(window.innerWidth <= sizeWindow ? {
                        // display: urlFile ? 'none' : 'block', // Ocultamos el árbol en móviles si hay un archivo abierto
                        width: '100%', // Ancho completo en móviles
                    } : {})
                }}

                >
                    <Tree
                        // style={{ '& .p-tree-toggler :click': { color: 'red' } }}
                        value={nodes}
                        className="w-full"
                        selectionMode="single"
                        selectionKeys={selectedNodeKey}
                        onSelectionChange={(e) => {
                            setSelectedNodeKey(e.value);
                        }}
                        onSelect={onSelect}
                        onExpand={loadOnExpand}
                    />
                </div>

                {/* Previsualización de archivo a la derecha */}
                <div style={{
                    width: "100%",
                    padding: '1rem',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                }}>
                    {/* Información del Presupuesto */}
                    {infoBudget && Object.keys(infoBudget).length > 0 && (
                        <div style={{
                            flex: '0 0 35%', // Tamaño fijo del contenedor
                            padding: '1.5rem',
                            // backgroundColor: '#f9f9f9',
                            // borderRadius: '16px',
                            // boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.2)',
                            overflowY: 'auto',
                            height: 'auto',
                            // position: 'sticky', // Fijo en pantallas grandes
                            top: '0',
                        }}>
                            <h3 style={{
                                textAlign: 'center',
                                marginBottom: '1.5rem',
                                fontSize: '.7rem',
                                color: '#333',
                            }}>
                                Información del Presupuesto
                            </h3>
                            <div
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(3, 1fr)', // Tres columnas
                                    gridTemplateRows: 'repeat(4, auto)',  // Cuatro filas
                                    gap: '.5rem',
                                }}
                            >
                                <p style={{ margin: '0', gridColumn: '2 / 4', gridRow: 'span 2' }}>
                                    <strong>Descripción:</strong> {` ${infoBudget?.vehicle?.description}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Nombre:</strong> {` ${infoBudget?.name}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Id seguro social:</strong> {` ${infoBudget?.insurance_id}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Marca:</strong> {` ${infoBudget?.vehicle?.brand}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Modelo:</strong> {` ${infoBudget?.vehicle?.model}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Tipo de motor:</strong> {` ${infoBudget?.engine_type_id === 1 ? "Gasolina/Diesel" : "Eléctrico"}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Año:</strong> {` ${infoBudget?.vehicle?.year}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Tipo auto:</strong> {` ${infoBudget?.vehicule_type === 1 ? "Nuevo" : "Usado"}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Precio (c/IVA):</strong> {` ${new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(infoBudget?.price || 0)}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Accesorios:</strong> {` ${infoBudget?.accesories}`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Plazo:</strong> {` ${infoBudget?.term} meses`}
                                </p>
                                <p style={{ margin: '0' }}>
                                    <strong>Estado de placa:</strong> {` ${infoBudget?.state_plate_id === 1
                                        ? "CDMX"
                                        : infoBudget?.state_plate_id === 2
                                            ? "Estado de México"
                                            : "Morelos"}`}
                                </p>
                                {infoBudget?.score && (
                                    <p style={{ margin: '0' }}>
                                        <strong>Score: </strong> {`${" "} ${infoBudget?.score} puntos`}
                                    </p>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Vista previa del archivo */}
                    {urlFile && (
                        <div style={{
                            flex: '1',
                            padding: '1rem',
                            backgroundColor: '#fff',
                            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                            // height: '100%',
                            // overflowY: 'auto',
                            height: '100%',
                            overflowY: 'auto',
                            marginLeft: '1rem',
                        }}>
                            <h3 style={{ textAlign: 'center', padding: "1rem 0" }}>
                                Previsualización del archivo
                            </h3>
                            {fileType === 'pdf' ? (
                                <iframe
                                    src={urlFile}
                                    width="100%"
                                    height="100%"
                                    title="file"
                                    style={{
                                        borderRadius: '16px',
                                        border: '1px solid #ccc',
                                    }}
                                />
                            ) : (
                                <img
                                    src={urlFile}
                                    alt="Preview"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        borderRadius: '16px',
                                        border: '1px solid #ccc',
                                        objectFit: 'contain',
                                    }}
                                />
                            )}
                        </div>
                    )}
                </div>

            </div>
        </>
    );
}